import { render, staticRenderFns } from "./merchant_settled.vue?vue&type=template&id=20964276&scoped=true"
import script from "./merchant_settled.vue?vue&type=script&lang=js"
export * from "./merchant_settled.vue?vue&type=script&lang=js"
import style0 from "./merchant_settled.vue?vue&type=style&index=0&id=20964276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20964276",
  null
  
)

export default component.exports